import HeaderVerde from '../HeaderVerde'
import Input from '../Input'
import Select from '../Select'
import Observacoes from '../Observacoes'
import Caixa from '../Caixa'
import CheckContainer from '../CheckContainer'
import CheckBox from '../CheckBox'
import React from 'react'

import { useSelector } from 'react-redux'

const TOenfermaria = (props) => {
    const modulo = props.modulo
    const updatedForm = useSelector((state) => state.addForm.qtdModulos[modulo])
    const condicional = useSelector((state) => state.addForm.modulos)
    const ficha = useSelector((state) => state.addForm.ficha)

    return (
        <>
            {RenderModulo()}
        </>
    )

    function RenderModulo() {
        let partes = []
        if (ficha[modulo]) var qtdFicha = ficha[modulo].length
        let quantidade = updatedForm || qtdFicha
        for (let n = 0; n < quantidade; n++) {
            partes.push(
                <Caixa>
                    <HeaderVerde texto="ENFERMARIA" />
                    <div style={{ textAlign: "left" }}>
                        <Input label="Enfermaria" nome="tonomedaenfermaria" modulo={modulo} index={n}
                            componentDisplay="inline-grid" widthWeb="60vw" widthMobile="80vw" marginR="3vw" />
                        <Input label="Número de Leitos" nome="toenfermarialeitos" modulo={modulo} index={n}
                            componentDisplay="inline-grid" widthWeb="10vw" widthMobile="80vw" marginR="3vw" tipo="number" />
                        <Input label="Nº de Pacientes Durante a Fiscalização" nome="toenfermariapacientesfiscalizacao" modulo={modulo} index={n}
                            componentDisplay="block" widthWeb="5vw" widthMobile="80vw" marginR="3vw" tipo="number" />
                        <Input label="Nº de Pacientes Assistidos" nome="toenfermariapacientesassistidos" modulo={modulo} index={n}
                            componentDisplay="block" widthWeb="5vw" widthMobile="80vw" marginR="3vw" tipo="number" />
                    </div>


                    <HeaderVerde texto="ASSISTÊNCIA DA TERAPIA OCUPACIONAL" />
                    <div style={{ textAlign: "left" }}>
                        <Select label="Há assistência da terapia ocupacional?" nome="haAssistenciaTO" modulo={modulo} index={n}
                            componentDisplay="inline-grid" widthWeb="20vw" widthMobile="80vw" marginR="3vw"
                            array={["Sim", "Não"]} />
                        <Input label="Quantos profissionais assistem no setor" nome="tofisioescala" modulo={modulo} index={n}
                            componentDisplay="inline-grid" widthWeb="5vw" widthMobile="80vw" marginR="3vw" tipo="number" />
                        {RenderQtdFisio()}
                    </div>


                    <HeaderVerde texto="PROFISSIONAIS NA ESCALAS" />
                    <div style={{ textAlign: "left" }}>
                        <Input label="Quantidade de Diaristas/Plantonistas" nome="toqtdescala" modulo={modulo} index={n}
                            widthWeb="5vw" widthMobile="80vw" marginR="3vw" tipo="number" />
                        <Select label="Assistência Terapêutica 7 dias/Semanas" nome="toassistencia7" modulo={modulo} index={n}
                            componentDisplay="inline-grid" widthWeb="20vw" widthMobile="80vw" marginR="3vw"
                            array={["sim", "não"]} />
                        <Select label="Jornada de Assistência" nome="toassit" modulo={modulo} index={n}
                            widthWeb="20vw" widthMobile="80vw" marginR="3vw"
                            array={["18h/dia", "24h/dia", "<18h/dia>"]} />
                        <Input label="Terapeuta(s) no Plantão" nome="toplantao" modulo={modulo} index={n}
                            componentDisplay="inline-grid" widthWeb="40vw" widthMobile="80vw" marginR="3vw" />
                    </div>

                    <HeaderVerde texto="LEGALIDADE" />
                    <div style={{ textAlign: "left" }}>
                        <Select label="CONFORMIDADE COM A RESOLUÇÃO COFFITO Nº  445/2014" nome="resolucao445" modulo={modulo} index={n}
                            componentDisplay="inline-grid" widthWeb="25vw" widthMobile="80vw" marginR="3vw"
                            array={["Sim", "Não"]} />
                        <Observacoes widthWeb="83vw" widthMobile="80vw" modulo={modulo} index={n} nome="observacoes" />
                    </div>
                </Caixa >
            )

            function RenderQtdFisio() {
                let campos = []
                if (condicional[modulo].length > 0) var array = condicional
                else var array = ficha
                var quantidade = array[modulo][n]["tofisioescala"]
                if (array[modulo][n]["tofisioescala"]) {
                    for (let i = 0; i < quantidade; i++) {
                        campos.push(
                            <div>
                                <Input label="Profissional" nome="tonomedoprofissional"
                                    modulo={modulo} index={n} subModulo="tonomedoprofissional" indexSub={i}
                                    componentDisplay="inline-grid" widthWeb="30vw" widthMobile="80vw" marginR="3vw" />
                                <Select label="Jornada de Trabalho" nome="tojornada"
                                    modulo={modulo} index={n} subModulo="tojornada" indexSub={i}
                                    componentDisplay="inline-grid" widthWeb="14vw" widthMobile="80vw" marginR="3vw"
                                    array={["Diarista", "Plantonista", "Ambos"]} />
                                <Select label="Horário de Trabalho" nome="tohrtrabalho"
                                    modulo={modulo} index={n} subModulo="tohrtrabalho" indexSub={i}
                                    componentDisplay="inline-grid" widthWeb="14vw" widthMobile="80vw" marginR="3vw"
                                    array={["12h diurno", "12h noturno", "6h matutino", "6h vespertino", "6h noturno", "24 horas"]} />
                                <Select label="Há demanda desassistida?" nome="demandadesassistida"
                                    modulo={modulo} index={n} subModulo="demandadesassistida" indexSub={i}
                                    componentDisplay="inline-grid" widthWeb="20vw" widthMobile="80vw" marginR="3vw"
                                    array={["Sim", "Não", "Não se aplica"]} />
                            </div>
                        )
                    }
                }
                return campos
            }
        }
        return partes
    }
}

export default TOenfermaria